"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const isString_1 = __importDefault(require("lodash/isString"));
const Utils_1 = require("../../utils/Utils");
const __DEV__ = process.env.NODE_ENV !== 'production';
const Image = (props) => {
    var _a, _b;
    const { src, alt, testId, fallbackSrc } = props, imgProps = __rest(props, ["src", "alt", "testId", "fallbackSrc"]);
    const dti = (0, Utils_1.getTestIdAttribute)(testId);
    if ((0, isString_1.default)(src)) {
        return ((0, jsx_runtime_1.jsx)("img", Object.assign({ src: src, onError: (e) => {
                if (fallbackSrc)
                    e.target.src = fallbackSrc;
            }, alt: alt }, dti, imgProps)));
    }
    // Above block is currently hit 100% since Src is always a relative path to the asset
    if (((src === null || src === void 0 ? void 0 : src.avif) || (src === null || src === void 0 ? void 0 : src.webp)) && !fallbackSrc) {
        if (__DEV__) {
            console.error("'avif' or 'webp' format requires 'fallbackSrc' to be provided.");
            return null;
        }
    }
    // TODO: Explore how to leverage src object to hit this block
    return (
    // format priority: avif > webp > svg > jpg > png
    (0, jsx_runtime_1.jsxs)("picture", { children: [(src === null || src === void 0 ? void 0 : src.avif) && (0, jsx_runtime_1.jsx)("source", Object.assign({ srcSet: src.avif }, dti)), (src === null || src === void 0 ? void 0 : src.webp) && (0, jsx_runtime_1.jsx)("source", Object.assign({ srcSet: src.webp }, dti)), (0, jsx_runtime_1.jsx)("img", Object.assign({ src: (_b = (_a = fallbackSrc !== null && fallbackSrc !== void 0 ? fallbackSrc : src === null || src === void 0 ? void 0 : src.svg) !== null && _a !== void 0 ? _a : src === null || src === void 0 ? void 0 : src.jpg) !== null && _b !== void 0 ? _b : src === null || src === void 0 ? void 0 : src.png, alt: alt }, dti, imgProps))] }));
};
exports.Image = Image;
